import { render, staticRenderFns } from "./CommunityTab.vue?vue&type=template&id=e4ad0542&scoped=true"
import script from "./CommunityTab.vue?vue&type=script&lang=js"
export * from "./CommunityTab.vue?vue&type=script&lang=js"
import style0 from "./CommunityTab.vue?vue&type=style&index=0&id=e4ad0542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ad0542",
  null
  
)

export default component.exports